import * as yup from 'yup';
import i18n from 'i18n-js';
import { MenuOption } from './components/GroupFormFields';

const CreateGroupValidationSchema = () =>
    yup.object().shape({
        name: yup
            .string()
            .max(128)
            .required(
                i18n.t('form.errors.required', {
                    name: 'Name',
                })
            ),
        selectedRestaurants: yup
            .array()
            .min(2, i18n.t('form.errors.minItems', { count: 2 }))
            .required(
                i18n.t('form.errors.required', {
                    name: 'Selected Restaurants',
                })
            ),
        selectedUsers: yup
            .array()
            .min(1, i18n.t('form.errors.minItems', { count: 1 }))
            .required(
                i18n.t('form.errors.required', {
                    name: 'Selected Users',
                })
            ),
        menuOption: yup
            .string()
            .oneOf([MenuOption.Copy, MenuOption.Empty])
            .required(
                i18n.t('form.errors.required', {
                    name: 'Menu Option',
                })
            ),
        selectedMenus: yup.array().when('menuOption', {
            is: (menuOption: string) => menuOption === MenuOption.Copy,
            then: yup
                .array()
                .min(1)
                .required(
                    i18n.t('form.errors.required', {
                        name: 'Selected Menus',
                    })
                ),
        }),
        catalogName: yup
            .string()
            .transform((_, originalValue) =>
                typeof originalValue === 'string' ? originalValue.trim() : originalValue
            )
            .when('menuOption', {
                is: (menuOption: string) => menuOption === MenuOption.Empty,
                then: yup.string().required(
                    i18n.t('form.errors.required', {
                        name: 'Catalog Name',
                    })
                ),
            }),
    });

export default CreateGroupValidationSchema;
